module.exports = __webpack_public_path__ + "static/media/BigOComplexity.04d1df50.png";